/*
 * Recipient category buttons (snippets/collection-category-nav.liquid).
 *
 * A button writes its filter value into #filters-params and asks the section's
 * <facets-filter> to re-render, so the grid, result count, chips, Filters badge, the
 * drawer's Shop for group and the URL all follow. assets/collection-toolbar.js places
 * the row (toolbar centre at 1025px+, above the toolbar below that).
 */
(function () {
  const CATEGORY_SCRIPT_VERSION = 2;
  if (window.__collectionCategoryNavVersion >= CATEGORY_SCRIPT_VERSION) return;
  window.__collectionCategoryNavVersion = CATEGORY_SCRIPT_VERSION;

  // --- URL rule (pure; exercised by scripts/collection-grid tests) ---

  /**
   * One category at a time: every category filter goes, then the picked one is set.
   * The configured filters (Style by default) are cleared too; price, sort and anything
   * else stay. Paging restarts. An empty param/value is "All".
   */
  const selectCategory = (query, { categoryParams = [], clearParams = [], param = '', value = '' }) => {
    const params = new URLSearchParams(query);
    const drop = new Set([...categoryParams, ...clearParams, 'page', 'section_id']);
    [...params.keys()].filter((key) => drop.has(key)).forEach((key) => params.delete(key));
    if (param && value) params.set(param, value);
    return params.toString();
  };

  window.CollectionCategoryNav = { selectCategory };

  if (typeof document === 'undefined' || !document.querySelector) return;

  // --- Behavior ---

  const splitParams = (raw) => (raw || '').split('|').filter(Boolean);
  let pendingKey = null;
  let liveRegion = null;

  /** Outside the re-rendered markup, so screen readers hear each new result count. */
  const announce = (text) => {
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.className = 'collection-category-nav__status';
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    window.requestAnimationFrame(() => {
      liveRegion.textContent = text;
    });
  };

  /** Mobile row scrolls sideways; keep the selected button in view (also from a shared URL). */
  const scrollSelectedIntoView = (nav) => {
    if (!nav || nav.scrollWidth <= nav.clientWidth) return;
    const selected = nav.querySelector('[data-category-button][aria-pressed="true"]');
    if (!selected) return;
    nav.scrollLeft = selected.offsetLeft - (nav.clientWidth - selected.offsetWidth) / 2;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-category-button]');
    if (!button || button.getAttribute('aria-pressed') === 'true') return;
    const nav = button.closest('[data-collection-category-nav]');
    const input = document.getElementById('filters-params');
    const facets = document.querySelector('facets-filter');
    if (!nav || !input || !facets) return;

    const url = new URL(input.value, window.location.origin);
    url.search = selectCategory(url.search.replace(/^\?/, ''), {
      categoryParams: splitParams(nav.dataset.categoryParams),
      clearParams: splitParams(nav.dataset.clearParams),
      param: button.dataset.param,
      value: button.dataset.value,
    });
    input.value = url.toString();
    pendingKey = button.dataset.categoryKey || null;
    facets.onSubmitHandler();
  });

  /** Called by the section after each re-render, after the toolbar has placed the row. */
  window.initCollectionCategoryNav = () => {
    const nav = document.querySelector('[data-collection-category-nav]');
    scrollSelectedIntoView(nav);
    if (!pendingKey || !nav) return;
    const key = pendingKey;
    pendingKey = null;
    [...nav.querySelectorAll('[data-category-button]')]
      .find((el) => el.dataset.categoryKey === key)
      ?.focus({ preventScroll: true });
    const count = document.querySelector('[data-render-result-count]')?.textContent.trim();
    if (count) announce(count);
  };

  const onReady = () => window.requestAnimationFrame(() => window.initCollectionCategoryNav());
  window.matchMedia('(min-width: 1025px)').addEventListener('change', onReady);
  document.addEventListener('shopify:section:load', onReady);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
})();
